import { useEffect } from "react";
import { ListSkeleton } from "../../skeletons/List";
import axios from "axios";
import { useState } from "react";
import DataTable from "../../components/Table";
import { Button, Container, Typography } from "@mui/material";
import FloatingActionButtons from "../../components/Fab";
import { useDashboardDrawer } from "../../providers/consumers/useDashboardDrawer";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear, setFieldState } from "../../store/formStore";
import { useSelector } from "react-redux";
import GzipHelper from "../../controllers/GzipHelper";
import { AuthHelper } from "../../controllers/AuthHelper";
import moment from "moment";

const ListExports = () => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const { pushMobileOpen, defaultOpen, addRouter } = useDashboardDrawer();
    const {builder, form, refs} = useBuilder();

    const elements = useSelector(state => state.elements);
    const comparator = (v1, v2) => moment(v1, 'DD/MM/YYYY HH:mm:SS').unix() - moment(v2, 'DD/MM/YYYY HH:mm:SS').unix();

    const columns = [
        { field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header' },
        { field: 'begin', headerName: 'Iniziato', width: 200, headerClassName: 'data-grid-header', sortComparator: comparator },
        { field: 'end', headerName: 'Finito', width: 200, headerClassName: 'data-grid-header', sortComparator: comparator},
        { field: 'ip', headerName: 'IP', width: 200, headerClassName: 'data-grid-header' },
        { field: 'filename', headerName: 'File', width: 200, headerClassName: 'data-grid-header', renderCell: (params) => {
            console.log(params);
        return (<a href={`https://crm-storage-files-no-worm.s3.eu-west-1.amazonaws.com/${params.formattedValue}`}>Download</a>)}
        },


    ];

    const getCustomers = async() => {
        const attributes = await AuthHelper.getUserFromIdToken();
        const res = await axios.get(`https://45bm2i72wc.execute-api.eu-west-1.amazonaws.com/dev/api/v1/contract/exports/${attributes.Username}`);
        const unzipped = await GzipHelper.unzip(res.data);
        console.log('unzipped', unzipped);
        setCustomers([...unzipped]);
        setLoading(false);
    }
    useEffect(() => {
        getCustomers();
        store.dispatch(clear())
        builder('customers.add');
    }, [])

    const handleClick = (data, name = null) => {
        store.dispatch(clear())
        builder('customers.add');
        if(data.row){
            Object.keys(data.row).forEach((key) => {
                store.dispatch(setFieldState({name: key, value: data.row[key]}));
            });
        }
        pushMobileOpen(true, 500, name ? name : "Modifica committente", data.row);

    }
    return (<Container sx={{paddingLeft: 24, paddingRight: 24, minWidth: '100vw', marginTop: '3rem'}}>
    
    <Typography variant="h4" color="primary" fontWeight="bold" textAlign="left" sx={{paddingBottom: '2rem', fontWeight: 'bold'}}>Lista esportazioni</Typography>
    
    {loading && <ListSkeleton />}
    {!loading && <DataTable data={customers} columns={columns} actions={[
    ]}/>}
    </Container>);
}

export default ListExports;